import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RuleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rule"}/>
}
